
<h2>Seleccione la empresa de la cual quiere imprimir carnets</h2>

<div id="company-container">
    <button mat-raised-button *ngFor="let company of data" (click)="choose($event,company)">
        <img [src]="s3Bucket+company.Logo" />
        {{company.Name}}</button>
</div>